import { atom } from "@mongez/react-atom";

export const isMobileAtom = atom<boolean>({
  key: "isMobile",
  default: false,
});
